export const RECAPTCHA_SITE_KEY = '6LeQbMErAAAAADu7iPDgobs2VXLFKSHApMSSSe2O';
export const RECAPTCHA_V2_SITE_KEY = '6LeDbMErAAAAAMrHSm8YyDcBzqYtK6TVjY1LbXfM';

export const GOOGLE_CLIENT_ID = '256611876551-sknlsr76atdfaaqulc9ihtdi43giduh7.apps.googleusercontent.com';
export const APPLE_CLIENT_ID = 'ai.prismax.app';

export const APPLE_REDIRECT_URI = typeof window !== 'undefined'
    ? `${window.location.origin}/`
    : 'https://app.prismax.ai/';
